import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const register = (data) => {
    return api.post(ENDPOINTS.AUTH.REGISTER, data);
};

export const login = (data) => {
    return api.post(ENDPOINTS.AUTH.LOGIN, data);
};

export const logout = () => {
    return api.post(ENDPOINTS.AUTH.LOGOUT);
};

export const forgotPassword = (data) => {
    return api.post(ENDPOINTS.AUTH.FORGOT_PASSWORD, data);
};

export const resetPassword = (data) => {
    return api.post(ENDPOINTS.AUTH.RESET_PASSWORD, data);
};

export const verifySession = () => {
    return api.get(ENDPOINTS.AUTH.VERIFY_SESSION);
};

export const refreshSession = () => {
    return api.post(ENDPOINTS.AUTH.REFRESH);
};
